<template>
    <div class="map-wrap">
        <iframe v-bind:src="map_url" frameborder="0" width="100%" height="100%"></iframe>
    </div>
</template>

<script>
export default {
    name: 'basicmap',
    props: {
        address: {
            type: String,
            required: true,
        }
    },
    computed: {
        map_url: function() {
            let API_Key = 'AIzaSyAM2uJCv_8nMPYA9chg6VD-2CtGOX5EuZE'
            let Q = this.address
            let url = `https://www.google.com/maps/embed/v1/place?key=${API_Key}&q=${Q}`
            url = encodeURI(url)
            return url
        }
    }
}
</script>

<style scoped>
    .map-wrap{
        position:relative;
        min-height: 300px;
        margin-bottom: 2rem;
    }

    .map-wrap iframe{
        position:absolute;
        left:0;
        top:0;
        width: 100%;
        height: 100%;
    }
</style>